import { render, staticRenderFns } from "./RsgUserWisePickup.vue?vue&type=template&id=aa538c24&"
import script from "./RsgUserWisePickup.vue?vue&type=script&lang=js&"
export * from "./RsgUserWisePickup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports